"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightChildAsButton = RightChildAsButton;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _Button = _interopRequireDefault(require("../atoms/Button"));
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Row = _interopRequireDefault(require("./Row"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
const _excluded = ["onClick", "text", "hide"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  title: null,
  titleHtmlType: 'title-3',
  titleAfterStyles: {},
  titleProps: {},
  description: '',
  descriptionAfterStyles: {},
  descriptionProps: {},
  rightChild: null,
  children: null,
  className: '',
  styles: '',
  forwardedRef: undefined,
  as: 'section'
};
function Section(props) {
  var _colors$FONT;
  const {
    title,
    titleHtmlType,
    titleAfterStyles,
    iconName,
    titleProps,
    description,
    descriptionAfterStyles,
    rightChild,
    children,
    className,
    styles,
    descriptionProps,
    forwardedRef,
    as
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    colors
  } = (0, _react2.useTheme)();
  const renderHeader = (0, _react.useMemo)(() => Boolean(description === null || description === void 0 ? void 0 : description.length) || Boolean(title) || Boolean(rightChild), [description, title, rightChild]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: className,
    styles: styles,
    as: as,
    ref: forwardedRef
  }, title && /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "name",
    content: title
  }), renderHeader && /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement(_Row.default, {
    align: "space-between",
    gap: 0,
    styles: cssTitleStyles
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 5
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    color: colors === null || colors === void 0 || (_colors$FONT = colors.FONT) === null || _colors$FONT === void 0 ? void 0 : _colors$FONT.TITLE,
    size: 17,
    datasets: {
      'data-title-icon': true,
      'data-title-icon-display': Boolean(iconName)
    }
  }), typeof title === 'string' ? /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    type: titleHtmlType,
    lineHeight: 30,
    size: 20,
    children: title,
    afterStyles: titleAfterStyles,
    "data-title": true
  }, titleProps)) : title), rightChild), Boolean(description === null || description === void 0 ? void 0 : description.length) && /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    type: "description",
    styles: cssDescriptionStyles,
    lineHeight: 25,
    afterStyles: descriptionAfterStyles,
    "data-description": true
  }, descriptionProps), description)), children);
}
const Container = _styled.default.section(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  [data-title-icon-display='false'] {\n    display: none;\n  }\n\n  @media screen and (min-width: 768px) {\n    gap: 15px;\n  }\n\n  ", "\n"])), _ref => {
  let {
    styles
  } = _ref;
  return styles;
});
const cssTitleStyles = (0, _react2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    h3 {\n      font-size: 30px;\n      line-height: 30px;\n    }\n\n    button {\n      font-size: 20px;\n    }\n  }\n"])));
const cssDescriptionStyles = (0, _react2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    font-size: 20px;\n    line-height: 30px;\n  }\n"])));
function RightChildAsButton(_ref2) {
  let {
      onClick,
      text,
      hide
    } = _ref2,
    restOfProps = _objectWithoutProperties(_ref2, _excluded);
  if (hide) return;
  return /*#__PURE__*/_react.default.createElement(RightChildButton, _extends({
    type: "link",
    width: "auto",
    "data-section-link": true,
    onClick: onClick,
    highlight: undefined,
    children: text
  }, restOfProps));
}
const RightChildButton = (0, _styled.default)(_Button.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 12px !important;\n  min-width: fit-content;\n\n  color: ", " !important;\n\n  @media screen and (min-width: 768px) {\n    font-size: 16px !important;\n  }\n"])), _ref3 => {
  var _theme$colors;
  let {
    theme
  } = _ref3;
  return theme === null || theme === void 0 || (_theme$colors = theme.colors) === null || _theme$colors === void 0 || (_theme$colors = _theme$colors.MAIN) === null || _theme$colors === void 0 ? void 0 : _theme$colors.INFO;
});
Section.RightChildAsButton = RightChildAsButton;
var _default = exports.default = Section;